
// Shared chrome for the redesigned client email suite: preheader, logo header,
// 600px white card (body via <slot>), and the required CMS disclaimer + postal
// address footer. Markup lifted verbatim from the approved demo; only the logo
// swaps the browser-only SVG data URI for the hosted no-tagline PNG.
export default {
    name: 'ClientSuiteFrame',
    props: {
        preheader: { type: String, default: '' },
        // Suppresses the hardcoded (800) 656-0894 in the header/footer for
        // sends that must contain zero phone numbers (AEP survey-nudge,
        // non-paying tier -- see aep-survey-nudge.vue). Every other caller
        // is unaffected by the default.
        showPhone: { type: Boolean, default: true },
    },
}
